module.exports = __webpack_public_path__ + "img/Vaccine-rafiki.fff83557.svg";